// extracted by mini-css-extract-plugin
module.exports = {"iconImg":"index_iconImg__2XPK1","menuStyle":"index_menuStyle__lpUPo"};